import React from 'react';
import PropTypes from 'prop-types';

import EditIcon from 'material-ui/svg-icons/editor/mode-edit';

import ListView from '../Common/ListView.react';
import ListItem from '../User/UserListItem';
import FlatButton from 'material-ui/FlatButton';
import LinearProgress from 'material-ui/LinearProgress';

import FilterStore from '../../stores/FilterStore';
import FilterResultsStore from '../../stores/FilterResultsStore';
import FilterActions from '../../actions/FilterActionCreator';
import UpIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
import DownIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-down';

import ROLES from '../../constants/Roles';
import buildContextMenu from '../Common/BuildContextMenu';

const Filter = React.createClass({

    getInitialState: function () {
        return {
            details: {
                id: '',
                name: '',
                description: '',
                filterCriteria: '',
                sysStatus: 0,
            },
            limit: 50,
            page: 0,
            loading: false,
            fetchedAll: false,
            showButton: false,
            results: [],
            actions: [],
            menuItems: [
                {
                    link: '/dashboard/filter/' + this.props.routeParams.id + '/edit',
                    icon: <EditIcon />,
                    label: 'Edit',
                    condition: {
                        roles: [ROLES.ADMIN]
                    }
                },
                {
                    type: 'deleteDialog',
                    dialogType: 'menu',
                    value: this.props.routeParams.id,
                    title: 'Delete ',
                    deleteAction: this._onDelete,
                    message: (
                                <span>
                                    Are you sure you want to delete this filter?
                                </span>
                            ),
                    condition: {
                        roles: [ROLES.ADMIN]
                    }
                }
            ],
            links: {
                back: '/dashboard/filters',
                edit: '',
            }
        }
    },

    componentDidMount: function() {
        FilterStore.addChangeListener(this._onChange);
        FilterActions.getById(this.props.routeParams.id);
        this.resultListener = FilterResultsStore.addListener(this.onResultsChange);
        FilterActions.getResults(this.props.routeParams.id, {limit: this.state.limit});

        window.addEventListener('scroll', this.handleScroll);

        this.setState({ actions: buildContextMenu(this.state.menuItems, this.context.auth) });
    },

    componentWillUnmount: function() {
        FilterStore.removeChangeListener(this._onChange);
        this.resultListener.remove();

        window.removeEventListener('scroll', this.handleScroll);
    },

    render: function () {

        return(
            <div ref="resultList">
                <ListView
                    title={this.state.details.name}
                    items={this.state.results}
                    itemDecorator={ListItem}
                    actions={this.state.actions}
                />
                {this.state.loading && (
                    <LinearProgress mode="indeterminate" />
                )}
                {this.state.showButton && (
                    <FlatButton
                        label={this.state.fetchedAll ? 'Back to top' : 'Load more'}
                        icon={this.state.fetchedAll ? <UpIcon/> : <DownIcon/>}
                        onTouchTap={this.state.fetchedAll ? () => window.scrollTo(0, 0) : this.loadNextPage}
                        disabled={this.state.loading}
                        fullWidth
                    />
                )}
            </div>
        );
    },

    _onChange: function(){
        const details = FilterStore.getById(this.props.routeParams.id);
        if (details !== undefined) {
            this.setState({details: details});
        }


    },

    onResultsChange: function() {
        const results = FilterResultsStore.getResults(this.props.routeParams.id);
        if (results !== undefined) {
            this.setState({results, loading: false, fetchedAll: FilterResultsStore.fetchedAll()});
        }
    },

    _onDelete: function(entityId) {
        if (entityId == this.props.routeParams.id) {
            FilterActions.delete(entityId);
            window.location.href = this.state.links.back;
        }
    },

    loadNextPage: function() {
        if (this.state.loading) { return; } //guard

        const page = (this.state.page + 1);
        FilterActions.getResults(this.props.routeParams.id, {page, limit: 50}, false);
        this.setState({page, loading: true});
    },

    handleScroll: function() {
        if (!this.state.showButton) {
            this.setState({showButton: true});
        }
        if (!this.state.fetchedAll && (window.scrollY + window.innerHeight) >= this.refs.resultList.clientHeight) {
            this.loadNextPage();
        }
    }

});

Filter.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default Filter;
